module.exports = __webpack_public_path__ + "img/02唐宋钢铁APP.98dc8544.jpg";